import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as Bulb } from "assets/svg/bulb.svg";
import T from "i18n";
import Base from "./Base";

const VisitHub = ({ className }) => {
  const classes = ["VisitHub"];
  if (className) classes.push(className);

  return (
    <Base
      className={className}
      Svg={Bulb}
      label={T({ path: "button.visitHub" }) !== null ? T({ path: "button.visitHub" }) : ""}
    />
  );
};

VisitHub.displayName = "VisitHub";

VisitHub.propTypes = {
  className: PropTypes.string,
};

VisitHub.defaultProps = {
  className: null,
};

export default VisitHub;
